import type {
  PlanningRange,
  StudentMeetingEdit,
  StudentMeetingEditDto,
  StudentMeetingEditRangeDto,
  StudentMeetingEditTimeframesDto,
} from "meetings/student-meeting/types";

const DEFAULT_TIME = "09:00";

const rangeFromDto = (dto: StudentMeetingEditRangeDto): PlanningRange => ({
  start_date: dto.start_date,
  end_date: dto.end_date ?? "",
  start_time: dto.start_time ?? "",
  end_time: dto.end_time ?? "",
});

const toBinary = (value: boolean | number | null | undefined): 0 | 1 =>
  value === true || value === 1 ? 1 : 0;

/**
 * Maps the `GET api/meetings/{id}` payload (MeetingResource) to the domain
 * model used to prefill the edit form. `timeframes` is `[]` when the meeting
 * has no planning row yet.
 */
export const studentMeetingEditFromDto = (
  dto: StudentMeetingEditDto,
): StudentMeetingEdit => {
  const timeframes: Partial<StudentMeetingEditTimeframesDto> = Array.isArray(
    dto.timeframes,
  )
    ? {}
    : dto.timeframes;

  return {
    id: dto.id,
    name: dto.name,
    message: dto.message ?? "",
    status: dto.status,
    mailStudent: toBinary(dto.mail_student),
    mailStudentText: dto.mail_student_text ?? "",
    allowStudentRatings: toBinary(dto.allow_student_ratings),
    mentorClasses: [...(dto.mentor_classes ?? [])],
    schedules: [...(dto.schedules ?? [])],
    autoShare: toBinary(timeframes.auto_share),
    opensAtDate: timeframes.opens_at_date ?? null,
    opensAtTime: timeframes.opens_at_time ?? DEFAULT_TIME,
    closedModifyDate: timeframes.closed_modify_at_date ?? null,
    closedModifyTime: timeframes.closed_modify_at_time ?? DEFAULT_TIME,
    closedNoModifyDate: timeframes.closed_no_modify_at_date ?? null,
    closedNoModifyTime: timeframes.closed_no_modify_at_time ?? DEFAULT_TIME,
    shareFeedbackDate: timeframes.share_feedback_at_date ?? null,
    shareFeedbackTime: timeframes.share_feedback_at_time ?? DEFAULT_TIME,
    archivedDate: timeframes.archived_at_date ?? null,
    archivedTime: timeframes.archived_at_time ?? DEFAULT_TIME,
    triangleFrom: timeframes.triangle_conversation_from ?? null,
    triangleTill: timeframes.triangle_conversation_till ?? null,
    feedbackReservations: (timeframes.feedback_reservations ?? []).map(
      rangeFromDto,
    ),
    speedDates: (timeframes.speed_dates ?? []).map(rangeFromDto),
    speedDatePreparations: (timeframes.speed_date_preparations ?? []).map(
      rangeFromDto,
    ),
  };
};
